import { message, Typography } from 'antd';
import type { StillStuckCardProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import { useHelpEvent } from '../../hooks';
import {
  AiStar,
  ChatBuubble,
  EmailSupport,
  PlayTriangleIcon,
} from '@/assets/icons/icons';

// currentColor so icons follow the card's text color in both themes.
const stuckIcons = {
  tour: () => <PlayTriangleIcon color='currentColor' />,
  assistant: () => <AiStar color='currentColor' size={16} />,
  chat: () => <ChatBuubble color='currentColor' />,
  email: () => <EmailSupport color='currentColor' />,
};

const StillStuckCard = ({ item, onSelect }: StillStuckCardProps) => {
  const { id, title, description, copy_value } = item;
  const trackEvent = useHelpEvent();
  const Icon = stuckIcons[id as keyof typeof stuckIcons];

  const handleCopy = async () => {
    if (!copy_value) return;
    try {
      await navigator.clipboard.writeText(copy_value);
      message.success('Email address copied');
      trackEvent({ event: 'help_support_email_copy' });
    } catch {
      message.error('Could not copy');
    }
  };

  return (
    <div className={styles.stillStuckCard}>
      <button
        type='button'
        className={styles.stillStuckCardMain}
        onClick={() => onSelect(item)}
      >
        <span className={styles.stillStuckIcon}>{Icon && <Icon />}</span>
        <span className={styles.stillStuckText}>
          <Typography.Text className={styles.stillStuckCardTitle}>
            {title}
          </Typography.Text>
          <span className={styles.stillStuckCardDescription}>
            {description}
          </span>
        </span>
      </button>

      {copy_value && (
        <button
          type='button'
          className={styles.stillStuckCopy}
          onClick={handleCopy}
        >
          Copy
        </button>
      )}
    </div>
  );
};

export default StillStuckCard;
